<template>
  <div>
    <div class="container-fluid d-flex justify-content-center align-items-center bg-custom">
      <div class="card custom-card shadow-lg p-4 w-100 mx-3">
        <h1 class="text-center text-light fw-bold mb-4">Categories List</h1>
        <div class="input-group mb-4">
          <span class="input-group-text bg-gradient text-white">
            <i class="fas fa-search" style="color: black"></i>
          </span>
          <input type="text" v-model="searchQuery" class="form-control search-box"
            placeholder="Search for a category..." />
        </div>
        <div v-if="loader" class="loader-overlay">
  <div class="fancy-loader"></div>
</div>

        <div class="d-flex justify-content-end mb-4">
          <button class="btn btn-warning" @click="addproductmodal">Add Category</button>
        </div>
        <div class="table-responsive">
          <table v-if="filteredData.length" class="table custom-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(category, index) in filteredData" :key="category.id">
                <td>{{ index + 1 }}</td>
                <td>{{ category.name }}</td>
                <td>
                  <button @click="confirmToggleCategory(category)" class="badge"
                    :class="category.is_active ? 'bg-success' : 'bg-danger'">
                    {{ category.is_active ? "Enable" : "Disable" }}
                  </button>
                </td>
                <td>
                  <button class="btn btn-warning btn-sm me-2" @click="openEditModal(category)">
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-if="!filteredData.length" class="text-center text-danger fw-bold no-data">
            No categories found.
          </p>
        </div>
      </div>
    </div>
    <div class="modal fade" id="confirmModal" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmModalLabel">Confirm Action</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            Are you sure you want to
            <strong>{{ selectedCategory?.is_active ? "disable" : "enable" }} </strong>this
            category?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
            type="button"
           class="btn btn-primary"
           :disabled="confirmBtnDisabled"
          @click="handleConfirmClick(selectedCategory)"
          data-bs-dismiss="modal"
           >
         Yes, Confirm
        </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModalLabel">Edit Category Name</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p v-if="selectedCategory && selectedCategory.name !== updatedCategoryName" class="modal-text-wrap">
             Are you sure you want to change
            <strong>{{ selectedCategory.name }}</strong> to
            <strong>{{ updatedCategoryName }}</strong>?
           </p>

            <input type="text" class="form-control" v-model="updatedCategoryName" placeholder="Enter new category name"
              required />
            <small v-if="catemptyerror" class="text-danger">
              <i class="fas fa-exclamation-circle"></i> {{ catemptyerror }}
            </small>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
  type="button"
  class="btn btn-primary"
  :disabled="!canUpdateCategory"
  @click="updateCategoryName"
>
  Save Changes
</button>

          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="addproductmodal1" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
      <div class="modal-dialog custom-modal1 modal-dialog-centered">
        <div class="modal-content p-2">
          <div class="modal-header py-2 px-3">
            <h6 class="modal-title" id="confirmModalLabel">Add New Category</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              style="font-size: 0.8rem;"></button>
          </div>
          <div class="modal-body px-3 py-2">
            <div class="mb-3 text-start">
              <label for="productName" class="form-label mb-1">Category Name</label>
              <input type="text" class="form-control" placeholder="Enter new category name" v-model="name" required />
              <small v-if="catemptyerror" class="text-danger">
              <i class="fas fa-exclamation-circle"></i> {{ catemptyerror }}
            </small>
            </div>
            <div class="mb-2 text-start">
            <!--   <label for="productStatus" class="form-label mb-1">Status</label>
              <select class=" form-control" id="productStatus">
                <option selected disabled>Select status</option>
                <option value="enable">Enable</option>
                <option value="disable">Disable</option>
              </select> -->
            </div>
          </div>
          <div class="modal-footer justify-content-end py-2">
            <button type="button" class="btn btn-secondary " data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary "  @click="addCategory">Add Category</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { EditCategoryName , AddCategory} from "../End Points/api";
import * as bootstrap from "bootstrap";
export default {
  data() {
    return {
      searchQuery: "",
      selectedCategory: null,
      updatedCategoryName: "",
      catemptyerror: "",
      name : "",
      loader: false,
      confirmBtnDisabled: false, 
      confirmClicked: false, 
      originalCategoryName: "",
  
    
    };
  },

  computed: {
    ...mapState(["categories"]),
    filteredData() {
      return this.searchQuery
        ? this.categories.filter((category) =>
          category.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
        : this.categories;
    },
    canUpdateCategory() {
    return (
      this.updatedCategoryName.trim() !== "" &&
      this.updatedCategoryName.trim() !== this.originalCategoryName.trim() &&
      !this.loader
    );
  },
  },

  mounted() {
  this.loader = true;
  this.fetchCategories()
    .finally(() => {
      this.loader = false;
    });
    this.catemptyerror = "";
    const modalEl = document.getElementById("confirmModal");
    modalEl.addEventListener('hidden.bs.modal', () => {
    this.confirmClicked = false;  
  });
},

  methods: {

    ...mapActions(["fetchCategories", "toggleCategoryStatus"]),
    async handleConfirmClick(category) {
      if (this.confirmClicked) return;
    this.loader = true
    this.confirmClicked = true;
    this.confirmBtnDisabled = true;

      try {
      await this.toggleCategoryStatus(category);
      this.successToast(`Category ${category.is_active ? "enable" : "disable"} successfully!`);
      await this.fetchCategories();


      const modalEl = document.getElementById("confirmModal");
      const modalInstance = bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) modalInstance.hide();
    } catch (error) {
      this.errorToast("Failed to update category status.");
    } finally {
        this.confirmBtnDisabled = false;
      this.loader = false
     
    }
  },
      successToast(msg) {
      this.$toast.success(msg, { timeout: 4000 });
    },
    errorToast(msg) {
      this.$toast.error(msg, { timeout: 5000 });
    },
    confirmToggleCategory(category) {
      this.selectedCategory = category;
      const modal = new bootstrap.Modal(
        document.getElementById("confirmModal")
      );
      modal.show();
    },
    addproductmodal() {
      var modal = new bootstrap.Modal(document.getElementById("addproductmodal1"));
      this.name = ""
      this.catemptyerror = "";
      modal.show();
    },
    openEditModal(category) {
      this.selectedCategory = category;
      this.updatedCategoryName = category.name;
      this.catemptyerror = "";
      this.originalCategoryName = category.name;
      const modal = new bootstrap.Modal(document.getElementById("editModal"));
      modal.show();
    },
    async updateCategoryName() {
      this.loader = true
      this.catemptyerror = "";
      if (!this.updatedCategoryName.trim()) {
        this.catemptyerror = "Category name cannot be empty";
        return;
      }
      try {
        const res = await EditCategoryName(this.selectedCategory.id, {
          name: this.updatedCategoryName,
        });
        if (res.status === 200) {
          this.selectedCategory.name = this.updatedCategoryName;
          this.fetchCategories();
          document
            .getElementById("editModal")
            .querySelector(".btn-close")
            .click();
          this.successToast("Category Updated Successfully ")
        } else {
          console.error("Error updating category name:", res);
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.catemptyerror = error.response.data.name
            ? error.response.data.name[0]
            : "An error occurred";
        } else {
          this.catemptyerror = "An unexpected error occurred.";
        }
        console.error("the Error:", error);
      }
      finally {
        this.loader = false
      }
    },
    async addCategory() {
  this.catemptyerror = "";
  if (!this.name.trim()) {
    this.catemptyerror = "Category name cannot be empty";
    return;
  }

  this.loader = true;
  try {
    const newCategory = { name: this.name };
    const response = await AddCategory(newCategory);

    if (response.status === 201 || response.status === 200) {
      this.fetchCategories(); 
      this.name = ""; 
      const modalElement = document.getElementById("addproductmodal1");
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance.hide();
        this.successToast("Category Added Successfully ")
    } else {
      this.catemptyerror = "Failed to add category. Please try again.";
    }
  } catch (err) {
    console.error(err);
    if (err.response?.data?.name) {
      this.catemptyerror = err.response.data.name[0];
      console.log("the error is ",this.catemptyerror)
    }
   
    else {
      this.catemptyerror = "An error occurred while adding the category.";
    }
  } finally {
    this.loader = false;
  }
}

  },
};
</script>

<style scoped>
.modal-text-wrap {
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  max-width: 100%;
}
.custom-card {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  color: white;
  border-radius: 15px;
  border: none;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
}

.search-box {
  border: none;
  border-radius: 25px;
  padding: 10px;
  font-size: 16px;
}

.search-input {
  width: 300px;
  height: 40px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  position: fixed;
}

.search-input:focus {
  border-color: #007bff;
  outline: none;
}

.custom-table th,
.custom-table td {
  padding: 12px;
  text-align: center;
  vertical-align: middle;
}

.badge {
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
}

.no-data {
  font-size: 1.2rem;
  font-weight: bold;
  color: #e74c3c;
  padding: 20px;
}

.custom-modal {
  max-width: 600px;
  /* Increase width */
  width: 100%;
}

.custom-modal .modal-content {
  min-height: 400px;
  /* Increase height */
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}


.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}
@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>